import { jsxs, jsx } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Stack, Heading, Bleed, Box } from "braid-design-system";
import { useMemo } from "react";
import { useJobDetailsViewContext } from "../CompanyProfile/CompanyProfile.mjs";
import { getPaddingX } from "../JDVLayout/JDVLayout.mjs";
import { translations } from "../../../components/CompetitiveJobs/.vocab/index.mjs";
import { JobCardLite } from "./JobCardLite/JobCardLite.mjs";
import { jobCardWrapper, jobCardWrapperForScrollOnTablet, horizontalScrollOnTablet } from "./CompetitiveJobs.css.mjs";
const CompetitiveJobs = ({ jobs }) => {
  const isEnableHorizontalScroll = jobs.length === 3;
  const { t } = useTranslations(translations);
  const { embedded } = useJobDetailsViewContext();
  const jdvPaddingXForTablet = useMemo(() => {
    const jdvPaddingX = getPaddingX({
      embedded
    });
    return typeof jdvPaddingX === "object" ? jdvPaddingX.tablet : jdvPaddingX || "none";
  }, [embedded]);
  return /* @__PURE__ */ jsxs(Stack, { space: "large", data: { testid: "competitive-jobs" }, children: [
    /* @__PURE__ */ jsx(Heading, { level: "4", children: t("Featured jobs", { jobCount: jobs.length }) }),
    /* @__PURE__ */ jsx(
      Bleed,
      {
        horizontal: {
          mobile: "none",
          tablet: isEnableHorizontalScroll ? jdvPaddingXForTablet : "none",
          desktop: "none"
        },
        children: /* @__PURE__ */ jsx(
          Box,
          {
            display: "flex",
            gap: "small",
            flexDirection: { mobile: "column", tablet: "row" },
            width: "full",
            className: {
              [horizontalScrollOnTablet]: isEnableHorizontalScroll
            },
            paddingLeft: {
              tablet: isEnableHorizontalScroll ? jdvPaddingXForTablet : "none",
              desktop: "none"
            },
            children: jobs.map((props, index) => {
              var _a, _b;
              return /* @__PURE__ */ jsx(
                Box,
                {
                  flexGrow: 1,
                  className: [
                    jobCardWrapper,
                    {
                      [jobCardWrapperForScrollOnTablet]: isEnableHorizontalScroll
                    }
                  ],
                  paddingRight: {
                    tablet: isEnableHorizontalScroll && index === jobs.length - 1 ? jdvPaddingXForTablet : "none",
                    desktop: "none"
                  },
                  children: /* @__PURE__ */ jsx(
                    JobCardLite,
                    {
                      id: props.id,
                      title: props.title,
                      advertiserName: props.company.name,
                      locationLabel: props.location,
                      listingDateLabel: props.postedDateFormatted,
                      srcLogo: (_b = (_a = props.branding) == null ? void 0 : _a.assets) == null ? void 0 : _b.logo.url,
                      saveJob: {
                        isApplied: Boolean(props.appliedDateFormatted),
                        isSaved: props.isSaved,
                        toggleSavedJob: props.onToggleSaveJob
                      }
                    }
                  )
                },
                index
              );
            })
          }
        )
      }
    )
  ] });
};
export {
  CompetitiveJobs
};
